import { ScheduleDayOfWeekEnum } from "../../types/schemes/dealers/schedules.js";
import { isDefined } from "../is/isDefined.js";
import { isFullDay } from "../is/isFullDay.js";
function prepareSchedule(schedule) {
  const weekdayOrder = Object.values(ScheduleDayOfWeekEnum);
  return [...schedule].filter((item) => isDefined(item.workdayStartTimeTimestamp) && isDefined(item.workdayEndTimeTimestamp)).sort((a, b) => weekdayOrder.indexOf(a.dayOfWeek) - weekdayOrder.indexOf(b.dayOfWeek)).map((item) => {
    const {
      workdayStartTimeTimestamp: workdayStartTime,
      workdayEndTimeTimestamp: workdayEndTime,
      breakStartTimeTimestamp: breakStartTime,
      breakEndTimeTimestamp: breakEndTime,
      dayOfWeek
    } = item;
    const day = weekdayOrder.indexOf(dayOfWeek) + 1;
    const isOpen24hours = isDefined(workdayStartTime) && isDefined(workdayEndTime) && isFullDay(workdayStartTime, workdayEndTime);
    if (isOpen24hours || !isDefined(breakStartTime) || !isDefined(breakEndTime)) {
      return {
        day,
        isOpen24hours,
        beforeBreak: [workdayStartTime, workdayEndTime]
      };
    }
    return {
      day,
      isOpen24hours,
      beforeBreak: [workdayStartTime, breakStartTime],
      afterBreak: [breakEndTime, workdayEndTime]
    };
  });
}
export {
  prepareSchedule
};
